import React, { ReactNode } from 'react'
import { Dialog } from '@base-ui/react/dialog'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { useHighlightedText } from '../../hooks/useHighlightedText'
import { MODULE_KEYS, SELF_SCHEDULING_DEFAULTS } from '../../moduleRegistry'
import { isFramed } from '../../../utils/isFramed'
import { ClockIcon, CloseIcon } from './icons'

interface SelfScheduleModalHeaderProps {
  showConfirmation: boolean
  advisorProfile?: ReactNode
}

const SelfScheduleModalHeader = ({ showConfirmation, advisorProfile }: SelfScheduleModalHeaderProps) => {
  const { confirmationHeader, confirmationSubtext } = useModuleConfig(MODULE_KEYS.selfScheduling, SELF_SCHEDULING_DEFAULTS)
  const highlightedConfirmationHeader = useHighlightedText(confirmationHeader)
  const highlightedConfirmationSubtext = useHighlightedText(confirmationSubtext)
  const dateTimeTitleClassName = isFramed()
    ? 'self_schedule_modal_subheading self_schedule_modal_datetime_title match-screen-app--framed'
    : 'self_schedule_modal_subheading self_schedule_modal_datetime_title'
  return <div className="self_schedule_modal_header">
    <div className="self_schedule_modal_header_content">
      {advisorProfile}
      {showConfirmation
        ? (<>
            <Dialog.Title render={<div className='self_schedule_modal_subheading' />}>
                {highlightedConfirmationHeader}
            </Dialog.Title>
            <Dialog.Description render={<div className='self_schedule_modal_subtext' />}>
                {highlightedConfirmationSubtext}
            </Dialog.Description>
          </>)
        : (<>
            <Dialog.Title render={<div className={dateTimeTitleClassName} />}>
                Select a Date & Time
            </Dialog.Title>
            <Dialog.Description render={<div className='self_schedule_modal_subtext' />}>
              <ClockIcon />
              30 minutes
            </Dialog.Description>
            <div className="self_schedule_modal_divider"></div>
          </>)}
    </div>
    <Dialog.Close className="self_schedule_modal_close" aria-label="Close modal">
      <CloseIcon />
    </Dialog.Close>
  </div>
}

export default SelfScheduleModalHeader
